<app-header-home [walletS]="walletS" [credentials]="credentials" [isLoading]="isLoading"></app-header-home>

<ion-content fullscreen>
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-grid fixed>
    <ion-row *ngIf="!brandingService.isMidiadesuerte()">
      <ion-col size="12" class="ion-text-center">
        <h1 class="ion-padding-start ion-padding-top">Bienvenido, {{ credentials?.name }}</h1>
        <p class="ion-padding-start welcome-lead">
          ¡Vive la emoción en tiempo real! entra a <span class="highlight">Casino</span> para girar y ganar, o apuesta
          en <span class="highlight">SportsBook</span> y celebra cada jugada.
          <br />
          <strong>¿Listo para tu próxima victoria?</strong>
        </p>
      </ion-col>
    </ion-row>

    <!-- Menú de tarjetas para CMillonario -->
    <ion-row
      class="ion-justify-content-center ion-text-center home-cards-row"
      *ngIf="!brandingService.isMidiadesuerte()"
    >
      <ion-col size="6" sizeMd="3">
        <ion-card class="home-card casino" button routerLink="/casino">
          <ion-card-content>
            <ion-icon name="game-controller-outline" size="large" color="primary"></ion-icon>
            <div>Casino | Casino Live</div>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" sizeMd="3">
        <ion-card class="home-card book" button routerLink="/book">
          <ion-card-content>
            <ion-icon name="american-football-outline" size="large" color="primary"></ion-icon>
            <div>SportsBook</div>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" sizeMd="3">
        <ion-card class="home-card wallet" button routerLink="/wallet">
          <ion-card-content>
            <ion-icon name="wallet-outline" size="large" color="primary"></ion-icon>
            <div>Wallet</div>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="6" sizeMd="3">
        <ion-card class="home-card profile" button routerLink="/account/profile">
          <ion-card-content>
            <ion-icon name="person-outline" size="large" color="primary"></ion-icon>
            <div>Perfil</div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Listado y filtros de juegos para Mi Día de Suerte -->
    <ng-container *ngIf="brandingService.isMidiadesuerte()">
      <!-- Chips de sorteos rápidos arriba -->
      <!-- <ion-row class="ion-no-padding ion-no-margin">
        <ion-col size="12" class="ion-no-padding ion-no-margin">
          <div class="chips-container">
            <span *ngFor="let item of sorteosHeader">
              <ion-chip
                color="medium"
                size="small"
                *ngIf="item.showButtonBar"
                outline="false"
                button
                [routerLink]="item.path"
              >
                <ion-label>
                  <ion-icon [src]="'/assets/frames/' + item.logo + '.svg'"></ion-icon>
                  <small>{{ item.shortName }}</small>
                </ion-label>
              </ion-chip>
            </span>
          </div>
        </ion-col>
      </ion-row> -->

      <!-- Carrusel Swiper de sorteos y videos en vivo -->
      <ion-row class="ion-no-margin ion-no-padding">
        <ion-col size="12" class="ion-no-margin ion-no-padding">
          <app-swipe [autoStart]="true" [showProgressBullet]="true" class="loteria-swiper">
            <!-- Slide de Chispazo -->
            <div class="swiper-slide">
              <ion-card button class="card-chispazo swiper-game-card" color="dark" [routerLink]="['/game/chispazo']">
                <ion-grid fixed>
                  <ion-row class="ion-align-items-center">
                    <ion-col size="6" class="ion-text-center">
                      <ion-img [src]="electronicLogo('Chispazo', '/assets/logos/chispazo.svg')"></ion-img>
                    </ion-col>
                    <ion-col size="6">
                      <h2 class="ion-text-center">¡Juega desde $10.00 pesos!</h2>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </div>

            <!-- Slide de Progol -->
            <div class="swiper-slide">
              <ion-card button class="card-progol swiper-game-card" color="dark" [routerLink]="['/game/progol']">
                <ion-grid fixed>
                  <ion-row class="ion-align-items-center">
                    <ion-col size="6" class="ion-text-center">
                      <ion-img [src]="electronicLogo('Progol', '/assets/logos/progol.svg')"></ion-img>
                    </ion-col>
                    <ion-col size="6">
                      <h2 class="ion-text-center">¡Anota y Gana la Millonada!</h2>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </div>

            <!-- Slide de Melate -->
            <div class="swiper-slide">
              <ion-card button class="card-melate swiper-game-card" color="dark" [routerLink]="['/game/melate']">
                <ion-grid fixed>
                  <ion-row class="ion-align-items-center">
                    <ion-col size="6" class="ion-text-center">
                      <ion-img
                        [src]="electronicLogo('Melate', '/assets/logos/melate-revancha-revanchita.svg')"
                      ></ion-img>
                    </ion-col>
                    <ion-col size="6">
                      <h2 class="ion-text-center">¡Juega desde $15.00 pesos!</h2>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </div>

            <!-- Slide de Melate Retro -->
            <div class="swiper-slide">
              <ion-card
                button
                class="card-melateretro swiper-game-card"
                color="dark"
                [routerLink]="['/game/melate', 'retro']"
              >
                <ion-grid fixed>
                  <ion-row class="ion-align-items-center">
                    <ion-col size="6" class="ion-text-center">
                      <ion-img [src]="electronicLogo('MelateRetro', '/assets/logos/melate-retro.svg')"></ion-img>
                    </ion-col>
                    <ion-col size="6">
                      <h2 class="ion-text-center">¡Melate Retro! Regresa a la suerte clásica</h2>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </div>

            <!-- Slide de Tris -->
            <div class="swiper-slide">
              <ion-card button class="card-tris swiper-game-card" color="dark" [routerLink]="['/game/tris']">
                <ion-grid fixed>
                  <ion-row class="ion-align-items-center">
                    <ion-col size="6" class="ion-text-center">
                      <ion-img [src]="electronicLogo('Tris', '/assets/logos/tris.svg')"></ion-img>
                    </ion-col>
                    <ion-col size="6">
                      <h2 class="ion-text-center">¡Juega Con $10.00 pesos!</h2>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </div>
          </app-swipe>
        </ion-col>
      </ion-row>
    </ng-container>

    <ion-row class="sorteos-card ion-padding-horizontal" *ngIf="brandingService.isMidiadesuerte()">
      <ion-col size="12">
        <ion-row class="ion-justify-content-center ion-align-items-center">
          <ion-col size="auto" class="ion-text-center">
            <ion-chip
              class="highlighted-chip"
              (click)="selectFilter('electronico')"
              [color]="selectedFilter === 'electronico' ? 'tertiary' : 'light'"
            >
              <small translate>home.filter.electronico</small>
              <ion-icon src="/assets/icons/sorteo.svg"></ion-icon>
            </ion-chip>
          </ion-col>
          <ion-col size="auto" class="ion-text-center">
            <ion-chip
              class="highlighted-chip"
              (click)="selectFilter('loteria')"
              [color]="selectedFilter === 'loteria' ? 'tertiary' : 'light'"
            >
              <ion-icon src="/assets/icons/loteria.svg"></ion-icon>
              <small translate>home.filter.loteria</small>
            </ion-chip>
          </ion-col>
        </ion-row>
      </ion-col>

      <!-- Banner de cierre de sorteos -->
      <ion-col size="12" *ngIf="isCierreSorteosActive" class="ion-padding-horizontal">
        <div class="cierre-sorteos-banner">
          <div class="banner-content">
            <ion-icon name="alert-circle-outline" class="banner-icon"></ion-icon>
            <span class="banner-text">{{ 'ALERT.SALE_CLOSED_MESSAGE' | translate }}</span>
          </div>
        </div>
      </ion-col>

      <!-- Si no hay sorteos de lotería disponibles para la venta -->
      <ion-col
        size="12"
        *ngIf="selectedFilter === 'loteria' && noLoteriaDrawsAvailable"
        class="ion-text-center ion-padding"
      >
        <p class="small-muted">{{ loteriaErrorMessage }}</p>
      </ion-col>

      <!-- Skeletons de carga animadas mientras se obtienen los juegos -->
      <ng-container *ngIf="isLoading || (!filteredGames.length && !noLoteriaDrawsAvailable)">
        <ion-col *ngFor="let dummy of [1, 2, 3, 4, 5, 6]" sizeXs="12" sizeMd="6" sizeLg="4">
          <ion-card class="card-4 game-item" style="opacity: 0.85">
            <ion-grid class="ion-no-padding ion-no-margin">
              <ion-row class="ion-no-padding ion-no-margin ion-align-items-center">
                <ion-col size="4" class="logo ion-no-padding logo-container ion-padding">
                  <ion-skeleton-text animated style="width: 100%; height: 80px; border-radius: 8px"></ion-skeleton-text>
                </ion-col>
                <ion-col class="game-text-container" size="8">
                  <h3 class="game-item-title" style="min-width: unset; width: 100%">
                    <ion-skeleton-text animated style="width: 70%; height: 16px; margin: 0 auto"></ion-skeleton-text>
                  </h3>
                  <h2 class="game-item-message" style="width: 100%">
                    <ion-skeleton-text animated style="width: 85%; height: 12px; margin: 4px auto"></ion-skeleton-text>
                  </h2>
                  <h1 class="ion-text-center game-item-amount" style="width: 100%">
                    <ion-skeleton-text
                      animated
                      style="width: 60%; height: 22px; margin: 6px auto; border-radius: 4px"
                    ></ion-skeleton-text>
                  </h1>
                </ion-col>
              </ion-row>
              <ion-row class="date-container" style="padding: 4px 8px">
                <ion-col size="6">
                  <ion-skeleton-text animated style="width: 80%; height: 12px"></ion-skeleton-text>
                </ion-col>
                <ion-col size="6" class="ion-text-end">
                  <ion-skeleton-text animated style="width: 80%; height: 12px; margin-left: auto"></ion-skeleton-text>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card>
        </ion-col>
      </ng-container>

      <ion-col *ngFor="let item of filteredGames" sizeXs="12" sizeMd="6" sizeLg="4">
        <ion-card
          class="card-4 game-item"
          [class.has-bd-logo]="hasRemoteElectronicLogo(item)"
          button
          [routerLink]="isAuthenticated ? item.path : null"
          (click)="!isAuthenticated && handleCardClick(item.path ? item.path.join('/') : '', $event)"
        >
          <ion-grid class="ion-no-padding ion-no-margin">
            <ion-row
              class="ion-no-padding ion-no-margin"
              [ngClass]="hasRemoteElectronicLogo(item) ? 'ion-align-items-stretch' : 'ion-align-items-center'"
            >
              <ion-col size="4" class="logo ion-no-padding logo-container" [ngClass]="getLogoContainerClasses(item)">
                <ion-img class="" [src]="getGameLogoSrc(item)"></ion-img>
              </ion-col>
              <ion-col class="game-text-container" size="8">
                <h3 class="game-item-title">{{ item.name }}</h3>
                <h2 class="game-item-message">{{ item.message }}</h2>
                <h1 class="ion-text-center game-item-amount" *ngIf="item.bag !== false">
                  <ion-icon slot="start" src="/assets/icons/cash-bag.svg"></ion-icon>
                  <span>
                    ${{ item.amount ?? item.price | number : (item.amount ? '0.2' : '0.0-0') }}
                    {{ item.amount ? '' : 'pesos' }}
                  </span>
                </h1>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="now" class="date-container">
              <ion-col class="close closed-label" size="12" *ngIf="isLoteriaGameClosed(item)">
                <h3 class="closed-status">Cerrado <ion-icon name="lock-closed-outline"></ion-icon></h3>
              </ion-col>
              <ion-col class="close" size="6" *ngIf="!isLoteriaGameClosed(item) && getGameCloseDate(item) as closeDate">
                <h3
                  *ngIf="closeDate | dateDiference : getCountdownReferenceDate(item) as diference"
                  [ngClass]="{ closer: diference.includes('min'), medium: diference.includes('ho') }"
                >
                  Cierra en: <ion-icon name="time-outline"></ion-icon><span>{{ diference }}</span>
                </h3>
              </ion-col>
              <ion-col class="next" size="6" *ngIf="!isLoteriaGameClosed(item) && getGameNextDate(item) as nextDate">
                <h3>
                  Próximo: <ion-icon name="calendar-clear-outline"></ion-icon
                  ><span>{{ nextDate | date : 'dd/MM/yyyy' }} </span>
                </h3>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="banner-row" *ngIf="!brandingService.isMidiadesuerte()">
      <ion-col size="12">
        <!-- Skeleton/placeholder mientras se cargan los banners -->
        <div *ngIf="!bannersLoaded || banners.length === 0" class="banner-skeleton">
          <ion-skeleton-text animated style="width: 100%; height: 200px; border-radius: 8px"></ion-skeleton-text>
        </div>

        <app-swipe
          *ngIf="bannersLoaded && banners.length > 0"
          class="banner-swipe"
          [autoStart]="true"
          [showProgressBullet]="true"
        >
          <div
            *ngFor="let banner of banners; let i = index"
            class="swiper-slide div-imag"
            [routerLink]="isAuthenticated ? '/' + banner.url : null"
            (click)="!isAuthenticated && handleCardClick('/' + banner.url, $event)"
          >
            <ion-img
              [src]="isSmallScreen ? banner.imageUrlPhone : banner.imageUrl"
              [alt]="banner.title"
              class="img-adapted"
              style="cursor: pointer"
              loading="eager"
            ></ion-img>
          </div>
        </app-swipe>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="footer-legal ion-text-center ion-padding" *ngIf="!brandingService.isMidiadesuerte()">
    <p class="legal-text">
      {{ brandingService.getFooterLegalText() }}
    </p>
  </div>
</ion-content>

<app-tab-bar *ngIf="brandingService.isMidiadesuerte()"></app-tab-bar>
